import { DateList } from '../date-list'
import { TransactionItemMobileSkeleton } from '../transaction-item/transaction-item-mobile-skeleton'
import { CCIcon, EmptyTransactionsIcon } from './icons'
import { TransactionListProps } from './transaction-list'

export function TransactionListMobile({
    transactions = [],
    loading,
    showPlaceholder,
}: TransactionListProps) {
    return (
        <div className='h-full overflow-auto scrollbar-thin scrollbar-thumb-whiteOverlay scrollbar-track-whiteOverlay scrollbar-thumb-rounded-full scrollbar-track'>
            {!loading && !!transactions.length && (
                <DateList items={transactions} />
            )}
            {!loading && !transactions.length && showPlaceholder && (
                <div className='flex flex-col items-center justify-center w-full gap-4 pt-8 '>
                    <CCIcon />
                    <p className='text-gray8'>Pick an account</p>
                </div>
            )}
            {!loading && !transactions.length && (
                <div className='flex flex-col items-center justify-center w-full gap-4 pt-8 '>
                    <EmptyTransactionsIcon />
                    <p className='text-gray8'>No transactions found</p>
                </div>
            )}

            {loading && (
                <div className='w-full'>
                    <div className='w-24 h-4 my-2 rounded bg-skeleton'></div>
                    <TransactionItemMobileSkeleton />
                    <TransactionItemMobileSkeleton />
                    <div className='w-24 h-4 my-2 rounded bg-skeleton'></div>

                    <TransactionItemMobileSkeleton />
                    <TransactionItemMobileSkeleton />
                    <TransactionItemMobileSkeleton />
                    <TransactionItemMobileSkeleton />
                    <div className='w-24 h-4 my-2 rounded bg-skeleton'></div>

                    <TransactionItemMobileSkeleton />
                    <TransactionItemMobileSkeleton />
                </div>
            )}
        </div>
    )
}
